module.exports = __webpack_public_path__ + "89e2e42a7adfb655e8c903e0e62c509b.svg";